<template>
    <validation-provider :rules="rules" :name="name" v-bind="$attrs" v-slot="{errors, valid, invalid, validated}">
        <b-form-group>
            <slot name="label">
                <label v-if="label" :class="labelClasses">
                    {{ label }}
                </label>
            </slot>
            <div :class="[
       {'input-group': hasIcon},
       {'focused': focused},
       {'input-group-alternative': alternative},
       {'has-label': label || $slots.label},
       inputGroupClasses
       ]">
                <div v-if="prependIcon || $slots.prepend" class="input-group-prepend">
                    <slot name="prepend">
                        <span class="input-group-text">
                            <i :class="prependIcon"></i>
                        </span>
                    </slot>
                </div>
                <slot v-bind="slotData">
                    <select v-bind="$attrs" :valid="valid" :required="required" v-on="listeners" class="form-control"
                            :class="[{'is-valid': valid && validated && successMessage}, {'is-invalid': invalid && validated}, inputClasses]">
                        <option value="" v-if="showBlank">Select</option>
                        <option v-for="item in actualOptions" :key="item.value" :value="item.value"
                                :selected="item.value === value" v-html="item.label"></option>
                    </select>
                </slot>
                <div v-if="appendIcon || $slots.append" class="input-group-append">
                    <slot name="append">
                        <span class="input-group-text">
                            <i :class="appendIcon"></i>
                        </span>
                    </slot>
                </div>
                <slot name="infoBlock"></slot>
            </div>
            <transition :name="animation" appear>
                <slot name="success">
                    <div class="valid-feedback" v-if="valid && validated && successMessage">
                        {{ successMessage }}
                    </div>
                </slot>
                <slot name="error" :errors="errors">
                    <div v-if="errors[0]" class="invalid-feedback" style="display: block;">
                        {{ errors[0] }}
                    </div>
                </slot>
            </transition>
        </b-form-group>
    </validation-provider>
</template>

<script>
import axios from 'secure-axios';
import ValidatedFieldMixin from './ValidatedFieldMixin';

export default {
    inheritAttrs: false,
    name: 'validated-select',
    mixins: [ValidatedFieldMixin],
    props: {
        showBlank: {
            type: Boolean,
            description: 'Whether input is required (adds an asterix *)',
            default: false
        },

        optionsURL: {
            type: String,
            description: 'Input type',
            default: ''
        },
        options: {
            type: Array,
            description: '',
            default: function () {
                return [];
            }
        }
    },
    mounted () {
        const that = this;

        that.actualOptions = that.options;

        const needOptions = this.optionsURL !== undefined && this.optionsURL !== null && this.optionsURL !== '';
        needOptions && axios.get(this.optionsURL).then(function (response) {
            that.actualOptions = response.data.data;
        });
    },
    data () {
        return {
            actualOptions: []
        };
    },
    computed: {},
    watch: {
        options () {
            this.actualOptions = this.options;
        }
    },
    methods: {
        updateValue (evt) {
            const selectedOptions = evt.target.selectedOptions;
            const result = [];
            const len = selectedOptions.length;
            let i;
            let currentItem;
            for (i = 0; i < len; i += 1) {
                currentItem = selectedOptions[i];
                currentItem = currentItem.value;
                result.push(currentItem);
            }

            let value;
            if (result.length > 1) {
                value = evt.target.value;
            } else {
                value = result;
            }
            this.$emit('input', value);
        }
    }
};
</script>
<style></style>
